import useAttendanceScan, {
    ATTENDANCE_ACTIONS,
    ATTENDANCE_SCAN_STATES
} from "./use-attendance-scan";
import useAttendanceMutationScan from "./attendance-use-mutation-scan";


const AttendanceHooks = {
    useScan: useAttendanceScan,
    useMutationScan: useAttendanceMutationScan
};

export {
    ATTENDANCE_ACTIONS,
    ATTENDANCE_SCAN_STATES,
    useAttendanceScan,
    useAttendanceMutationScan
};

export default AttendanceHooks;
